import { ApiRoutes, AppPaginationOptions, QueryError, WithPagination } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Domain, SearchConsoleUrlInspectionDomainsQueryKeys } from '@/modules/Domains';
import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

export const useGetAllSearchConsoleUrlInspectionDomainsQuery = (siteId: string, paginationOptions: AppPaginationOptions) =>
  buildQuery<
    WithPagination<Pick<Domain, 'id' | 'name' | 'isGoogleVerificated' | 'isSitesMain'>
  >, QueryError>(
    [SearchConsoleUrlInspectionDomainsQueryKeys.GetAll, siteId, paginationOptions],
    async () => {
      const { data } = await apiExecutor.get(ApiRoutes.SiteDomainsSearchConsoleUrlInspection.replace(':siteId', siteId), {
        params: paginationOptions
      });
      return data;
    }
  );

export const useGetByIdSearchConsoleUrlInspectionDomainsQuery = (siteId: string, domainId: string) =>
  buildQuery<void, QueryError>([SearchConsoleUrlInspectionDomainsQueryKeys.GetById, siteId, domainId], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.SiteDomainsSearchConsoleUrlInspectionById.replace(':siteId', siteId).replace(':domainId', domainId)
    );
    return data;
  });

export const useInspectUrlInSearchConsoleMutation = (siteId: string, domainId: string) =>
  buildMutation<
    SearchConsoleUrlInspection, QueryError, { pageNodeId: string; }
  >([SearchConsoleUrlInspectionDomainsQueryKeys.Inspect, siteId, domainId], async (postData) => {
    const { data } = await apiExecutor.post(
      ApiRoutes.SiteDomainsSearchConsoleUrlInspectionInspect.replace(':siteId', siteId).replace(':domainId', domainId),
      { ...postData }
    );
    return data;
  });
